var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReasonsDeclarations(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 21.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.9,18.3h-6.3c-2.5,0-4.6-2-4.6-4.6V4.6C0,2.1,2.1,0,4.6,0h13.7c2.5,0,4.6,2.1,4.6,4.6v3.4c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1v-3.4c0-1.3-1-2.3-2.3-2.3H4.6c-1.3,0-2.3,1-2.3,2.3v9.1c0,1.3,1,2.3,2.3,2.3h6.3c.6,0,1.1.5,1.1,1.1s-.5,1.1-1.1,1.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.4,13.7h-5.7c-.6,0-1.1-.5-1.1-1.1s.5-1.1,1.1-1.1h5.7c.6,0,1.1.5,1.1,1.1s-.5,1.1-1.1,1.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.1,10.3h-3.4c-.6,0-1.1-.5-1.1-1.1s.5-1.1,1.1-1.1h3.4c.6,0,1.1.5,1.1,1.1s-.5,1.1-1.1,1.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.3,10.3h-1.1c-.6,0-1.1-.5-1.1-1.1s.5-1.1,1.1-1.1h1.1c.6,0,1.1.5,1.1,1.1s-.5,1.1-1.1,1.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.3,21.7h-3.4c-.6,0-1.1-.5-1.1-1.1v-3.4c0-.3.1-.6.3-.8l3.9-3.9c1.3-1.3,3.7-1.3,5,0s1,1.6,1,2.5-.4,1.8-1,2.5l-3.9,3.9c-.2.2-.5.3-.8.3ZM16,19.4h1.8l3.5-3.6c.2-.2.4-.6.4-.9s-.1-.7-.4-.9c-.5-.5-1.3-.5-1.8,0h0s-3.6,3.5-3.6,3.5v1.8ZM18.8,13.3h0,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReasonsDeclarations);
export default __webpack_public_path__ + "static/media/reasons-declarations.d7a74400f498e4986aac059b48741985.svg";
export { ForwardRef as ReactComponent };